export interface ShopNotice {
  /** Показывать ли бегущую строку в шапке */
  enabled: boolean;
  /** Текст строки */
  text: string;
  /** Цвет фона строки (#RRGGBB) */
  color: string;
}

export interface ShopConfig {
  cart_public: boolean;
  /** Видны ли цены всем посетителям (по умолчанию да) */
  prices_public?: boolean;
  /** Приостановлен ли приём заказов (магазин открыт, но оформить нельзя) */
  purchase_disabled?: boolean;
  /** Бегущая строка в шапке */
  notice?: ShopNotice;
  // Подключена ли онлайн-оплата CDEK Pay
  online_payment?: boolean;
  /** Как оплачиваются новые заказы: на сайте или при получении в СДЭК */
  payment_mode?: "online" | "cod";
  /** Клиентский возврат СДЭК: код магазина, ссылка на сайт СДЭК, штрихкод */
  client_return?: ClientReturnInfo;
}

export interface ClientReturnInfo {
  code: string;
  link: string | null;
  barcode: string;
  phone: string;
}

// Публичные настройки витрины, заданные в админке.
// Значение подтягивается один раз при SSR (см. app/plugins/auth.ts) и
// попадает в payload, поэтому на клиенте отдельного запроса не происходит.
export const useShopConfig = () =>
  useState<ShopConfig>("shopConfig", () => ({ cart_public: false }));
